import { useMemo } from "react";
import { useTheme } from "../base/ThemeContext";
import { useWindowSizeClass } from "../base/WindowSizeClassContext";
import { useWindowSize } from "./use-window-size";
import { useSpacing } from "../base/SpacingContext";
import { useSurfaceScale } from "./use-surface-scale";
import { useSurfaceColor } from "./use-surface-color";
export const useStyles = (factory, deps) => {
    const theme = useTheme();
    const surfaceScale = useSurfaceScale();
    const surfaceColor = useSurfaceColor();
    const windowSizeClass = useWindowSizeClass();
    const windowSize = useWindowSize();
    const spacing = useSpacing();
    return useMemo(() => factory({ ...theme, surfaceScale, surfaceColor, windowSizeClass, windowSize, spacing }), [theme, windowSizeClass, deps]);
};
